const purple = '#c792ea';

const colors = {
  primary: purple,
  white: '#ffffff',
  black: '#010101',
  darkGray: '#aaaaaa',
  gray: '#dddddd',
  lightPurple: '#ffe3fe'
};

export default colors;
